/* eslint-disable react/prop-types */
import React from 'react';
import { Survey } from "../Survey";
import Modal from 'react-modal';
import { _SurveyStyleWrapper } from "./style";
var modalStyles = {
  overlay: {
    zIndex: 5000,
    backgroundColor: 'rgba(24, 39, 56, 0.85)'
  },
  content: {
    bottom: 'auto',
    height: 'fit-content',
    left: '50%',
    marginRight: '-50%',
    padding: '25px',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '55%',
    overflow: 'visible',
    borderRadius: '12px'
  }
};
var SurveyWrapper = function SurveyWrapper(_ref) {
  var currentUserRole = _ref.currentUserRole,
    surveyJSON = _ref.surveyJSON,
    onDeclineSurvey = _ref.onDeclineSurvey,
    onCompleteSurvey = _ref.onCompleteSurvey;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    onRequestClose: onDeclineSurvey,
    style: modalStyles,
    ariaHideApp: false
  }, /*#__PURE__*/React.createElement(_SurveyStyleWrapper, {
    survey: currentUserRole
  }, /*#__PURE__*/React.createElement(Survey, {
    json: surveyJSON,
    onComplete: onCompleteSurvey
  })));
};
export default SurveyWrapper;